import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Box,
  TableHead,
} from '@mui/material';
import {
  useParams,
} from 'react-router';
import { PlaceHolderText } from 'components/PlaceholderCard/PlaceholderCard';
import Progress from 'components/Progress/Progress';
import { Card, Typography } from 'bso-ui';
import PAGES from 'common/pages';
import Toolbar from 'components/Toolbar/Toolbar';
import API from 'common/api';
import useList from 'hooks/useList';
import RadioDeviceRow from './RadioDeviceRow';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3)
  }
}));

const RadioDevicesList = () => {
  const classes = useStyles();
  const { id, name } = useParams();
  const backlink = `${PAGES.RADIOS}/${id}`;
  const query = {
    storeKey: `circuit-${name}`,
    apiEndpoint: `${API.MONITORING_RESULTS}/${name}/`,
  };

  const [{
    data, isLoading, isError
  }] = useList(query.storeKey, query.apiEndpoint, null, { refetchInterval: 60000 });

  const getdevicesList = (res) => {
    let deviceList = [];
    let latestDevices = res[0].check?.zipinfo?.circuit?.devices;
    let latestTimestamp = res[0]?.check?.executed;
    for (let i = 0; i < res.length; i++) {
      if (latestTimestamp < res[i].check?.executed) {
        latestTimestamp = res[i].check?.executed;
        latestDevices = res[i].check?.zipinfo?.circuit?.devices;
      }
    }
    if (Object.keys(latestDevices).length > 0) {
      deviceList = Object.keys(latestDevices)?.filter((deviceName) => deviceName.startsWith('ULR'));
    }
    return deviceList || [];
  };

  if (isError) {
    return (
      <div>
        <PlaceHolderText variant="h3" content="Error fetching devices" height="100%" />
      </div>
    );
  }

  const renderData = () => (
    <Card id="RadioDevicesCard">
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><Typography variant="subtitle1">Device</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Ping</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Rssidbm</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Ber</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Temperature</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Tribinput</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Txpowerdbm</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Weather</Typography></TableCell>
            </TableRow>
          </TableHead>
          {data
            && data?.length > 0 && (
            <TableBody>
              {getdevicesList(data)?.map((deviceName) => (<RadioDeviceRow deviceName={deviceName} />))}
            </TableBody>
          )}
        </Table>
      </CardContent>
    </Card>
  );

  return (
    <div className={classes.root}>
      <Toolbar backLink={backlink} title={name || 'Radio devices'} noUnderscore />
      {!isLoading && data
        ? (
          <Box p={3}>
            {renderData()}
          </Box>
        ) : <Progress />}

    </div>
  );
};

export default RadioDevicesList;
